<template>
  <div>
    <div class="card shadow-sm border-0 p-4 mb-4">
      <!-- Header Title -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 class="fw-bold mb-0 text-primary">
          <i class="bi bi-file-earmark-bar-graph me-2"></i>
          Income & Expense Report
        </h5>
      </div>

      <!-- Date Filters -->
      <div class="row g-3 align-items-center">
        <div class="col-md-6">
          <label class="form-label fw-semibold small text-secondary mb-1">
            <i class="bi bi-calendar3 me-1"></i>{{ $t('start_date') }}
          </label>
          <input
            type="date"
            class="form-control shadow-sm rounded-pill"
            v-model="filters.start_date"
          />
          <div v-if="errors.start_date" class="text-danger small mt-1">
            <i class="bi bi-exclamation-circle"></i> {{ errors.start_date }}
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label fw-semibold small text-secondary mb-1">
            <i class="bi bi-calendar3 me-1"></i>{{ $t('end_date') }}
          </label>
          <input
            type="date"
            class="form-control shadow-sm rounded-pill"
            v-model="filters.end_date"
          />
          <div v-if="errors.end_date" class="text-danger small mt-1">
            <i class="bi bi-exclamation-circle"></i> {{ errors.end_date }}
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="text-muted my-4" />

      <!-- Buttons -->
      <div class="d-flex justify-content-start gap-3 flex-wrap">
        <button @click="submitReport" class="btn btn-outline-primary rounded-pill px-4">
          <i class="bi bi-arrow-repeat me-2"></i>  Search
        </button>  
      </div>
    </div>

    <div class="card shadow-sm border-0 p-4 mb-4" v-if="incomes.length > 0 || expenses.length > 0">
      <!-- Header Title -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 class="fw-bold mb-0 text-primary">
          <i class="bi bi-file-earmark-bar-graph me-2"></i>
          Income & Expense Report
        </h5>
      </div>


      <div class="table-responsive">
        <table class="table caption-top table1  text-uppercase">
          <caption class="text-center">
          	<strong class="text-dark">Form: {{ filters.start_date ? dateFormat(filters.start_date) : '' }} - To: {{ filters.end_date ? dateFormat(filters.end_date) : '' }}</strong>
          </caption>
          <thead>
            <tr>
              <th>{{$t('expense')}}({{$t("debit")}})</th>
              <th class="text-end">{{ $t("amount") }}</th>
              <th>{{$t('income')}}({{$t("credit")}})</th>
              <th class="text-end">{{ $t("amount") }}</th>
            </tr>
          </thead>
          <tbody>
          	<tr>
          		<td colspan="2">
          				<tbody>
          					<tr v-for="expense in expenses">
          						<td>{{expense.account_id}}-{{ getHeadName(expense.account_id) }}</td>
          						<td class="text-end">{{ expense.total_debit}}</td>
          					</tr>
          				</tbody>
          		</td>
          		<td colspan="2">
          				<tbody>
          					<tr v-for="income in incomes">
          						<td>{{income.account_id}}-{{ getHeadName(income.account_id) }}</td>
          						<td class="text-end">{{ income.total_credit}}</td>
          					</tr>
          				</tbody>
          		</td>
          	</tr>
          </tbody>
          	<tfoot>
          		<tr>
	          		<th class="text-end">Total</th>
					      <th class="text-end">{{(total.debit).toFixed(2)}}</th>
			      	  <th class="text-end">Total</th>
			      	  <th class="text-end">{{(total.credit).toFixed(2)}}</th>
          		</tr>
		    </tfoot>
        </table>

      </div>
    </div>
  </div>
</template>


<script>
import apiUrls from "@/urls";
import { useToast } from 'vue-toastification';
import feather from "../../../../../public/assets/js/feather.min";
import debounce from 'lodash.debounce'
import dayjs from 'dayjs'

export default {
  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      filters: {
        start_date: "",
        end_date: "",
      },
      errors: {},
      incomes:[],
      expenses:[],
      heads:[],
      total:{
      	debit:0,
      	credit:0,
      }
    };
  },
  created() {
  },
  mounted(){
  	this.geAccountsHead()
  },
  methods: {
    dateFormat(date){
      if(!date) return;
      return dayjs(date).format('DD-MM-YYYY')
    },

    getHeadName(account_id) {
      
        const head = this.heads.find(item => item.account_id == account_id)
        return head ? head.node : ''
    },
  	async geAccountsHead(){
  		const response = await this.$axios.get(apiUrls.chart_of_accounts.get, {
            params: {status:'Child' }
          })
  		this.heads = response.data
  	},
	async submitReport() {
	    try {

	      const response = await this.$axios.get(apiUrls.report_income_expense.get, {
	          params: this.filters
	        });
	      console.log(response)
	      this.incomes = response.data.incomes
	      this.expenses = response.data.expenses

	      this.total.debit = 0
	      this.total.credit = 0
	      
	      this.incomes.map(item => {
  		    	const itemDebit = parseFloat(item.total_debit);
  		    	const itemCredit = parseFloat(item.total_credit);
  		        this.total.credit += itemCredit-itemDebit;
	      })
	      this.expenses.map(item => {
  		    	const itemDebit = parseFloat(item.total_debit);
  		    	const itemCredit = parseFloat(item.total_credit);
  		        this.total.debit += itemDebit-itemCredit;
	      })

	    } catch (error) {
	      console.log(error)
	    }
	},

    
  }
}

</script>

<style scoped>
.table1 td {
    vertical-align: unset !important;
}
.table1 > tbody > tr > td > tbody td{
	width:100% !important;
	padding-right: 0px !important;
	padding-left: 0px !important;
}
.table1 > tbody > tr > td:first-child{
	border-right: double !important;
}
.table1 > tfoot > tr > th:nth-child(2){
	border-right: double !important;
}
caption{
  font-size:18px !important;
}
</style>